module.exports = __webpack_public_path__ + "static/img/Institutional_bannerone_bg.bc357ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/enterpriseEdition/Institutional_bannerone_bg.png
// module id = Grxr
// module chunks = 14